import { IScheduleJob } from '../common/schedule.service/schedule.job.model';
import { KPIService } from '../modules/kpi/kpi.service';

export class IndicatorUpdater implements IScheduleJob {
  id = 'IndicatorUpdater';
  udpateInterval = 60;
  callback = () => {
    this.kpiService.update(this.profileId);
  }

  constructor(public profileId: string, private kpiService: KPIService) {
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule.jobs/IndicatorUpdater.ts